import React from 'react';
import { Divider, Form, Radio, Label } from 'semantic-ui-react';

const VariationSelection = ({
  variations,
  selectedVariation,
  onSelectVariation,
  showDivider = true,
  checkoutDisabled,
}) => {
  return (
    <div className="item-cart-variation-selection">
      {showDivider && <Divider />}
      <div className="variation-selection-header">
        <h5>CHOOSE A TYPE</h5>
        <Label color="blue">REQUIRED</Label>
      </div>
      <Form>
        {variations.map(({ name, price }, index) => (
          <div className="variation-selection-radio" key={name}>
            <Form.Field>
              <Radio
                disabled={checkoutDisabled}
                label={name}
                name="variation"
                value="this"
                checked={
                  `${name}${price}` === `${selectedVariation.name}${selectedVariation.price}`
                }
                onChange={() => onSelectVariation(index)}
              />
            </Form.Field>
            <div>{price && price !== 0 ? `$${price.toFixed(2)}` : '-'}</div>
          </div>
        ))}
      </Form>
    </div>
  );
};

export default VariationSelection;
